import { render, staticRenderFns } from "./asset-picker-drawer.vue?vue&type=template&id=6d49497e&"
import script from "./asset-picker-drawer.vue?vue&type=script&lang=js&"
export * from "./asset-picker-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports